// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__JXzi\\+.styles_ocean-50__X59v\\+ {
  color: #e6f2ff;
}

.styles_color__JXzi\\+.styles_ocean-100__EdKRE {
  color: #e6f2ff;
}

.styles_color__JXzi\\+.styles_ocean-200__sSlq9 {
  color: #b3daff;
}

.styles_color__JXzi\\+.styles_ocean-300__IUwSg {
  color: #7abfff;
}

.styles_color__JXzi\\+.styles_ocean-400__Uxy7R {
  color: #2392fb;
}

.styles_color__JXzi\\+.styles_ocean-500__-pl5N {
  color: #0074e0;
}

.styles_color__JXzi\\+.styles_ocean-600__MbnwR {
  color: #043571;
}

.styles_color__JXzi\\+.styles_space-50__CpgSu {
  color: #f0f0f0;
}

.styles_color__JXzi\\+.styles_space-100__0in8r {
  color: #e3e3e3;
}

.styles_color__JXzi\\+.styles_space-200__-5kZS {
  color: #bfbfbf;
}

.styles_color__JXzi\\+.styles_space-300__y8tps {
  color: gray;
}

.styles_color__JXzi\\+.styles_space-400__JfTXJ {
  color: #616161;
}

.styles_color__JXzi\\+.styles_space-500__DHi63 {
  color: #283439;
}

.styles_color__JXzi\\+.styles_gray-50__BPL78 {
  color: #eff3f6;
}

.styles_color__JXzi\\+.styles_gray-100__w4yHf {
  color: #e6ecef;
}

.styles_color__JXzi\\+.styles_gray-200__vQN7V {
  color: #cfd8de;
}

.styles_color__JXzi\\+.styles_gray-300__4Q-H0 {
  color: #a8b9c2;
}

.styles_color__JXzi\\+.styles_gray-400__wFpDT {
  color: #7e98a5;
}

.styles_color__JXzi\\+.styles_gray-500__AXoZx {
  color: #738f9c;
}

.styles_color__JXzi\\+.styles_green-50__lY50r {
  color: #e3fdf6;
}

.styles_color__JXzi\\+.styles_green-100__bnEzv {
  color: #c5f6ea;
}

.styles_color__JXzi\\+.styles_green-200__W5M6R {
  color: #69ddc2;
}

.styles_color__JXzi\\+.styles_green-300__m\\+\\+do {
  color: #45bfa3;
}

.styles_color__JXzi\\+.styles_green-400__oq6yX {
  color: #1cab8a;
}

.styles_color__JXzi\\+.styles_green-500__XNpnT {
  color: #128268;
}

.styles_color__JXzi\\+.styles_red-50__4HS07 {
  color: #fff0f3;
}

.styles_color__JXzi\\+.styles_red-100__yjZSd {
  color: #f9d2db;
}

.styles_color__JXzi\\+.styles_red-200__oKDl7 {
  color: #f8b4c4;
}

.styles_color__JXzi\\+.styles_red-300__pp24U {
  color: #e85e81;
}

.styles_color__JXzi\\+.styles_red-400__sI9Tf {
  color: #e23661;
}

.styles_color__JXzi\\+.styles_red-500__w2EA5 {
  color: #b82348;
}

.styles_color__JXzi\\+.styles_yellow-50__7W8Y8 {
  color: #fffae6;
}

.styles_color__JXzi\\+.styles_yellow-100__LhL5q {
  color: #fff0b3;
}

.styles_color__JXzi\\+.styles_yellow-200__7NFrt {
  color: #ffe380;
}

.styles_color__JXzi\\+.styles_yellow-300__Jstr0 {
  color: #ffcf57;
}

.styles_color__JXzi\\+.styles_yellow-400__6QqBQ {
  color: #ffc60a;
}

.styles_color__JXzi\\+.styles_yellow-500__P8pAr {
  color: #ffb700;
}

.styles_color__JXzi\\+.styles_orange-50__Sk5g9 {
  color: #fff2eb;
}

.styles_color__JXzi\\+.styles_orange-100__QnbuV {
  color: #ffe4d6;
}

.styles_color__JXzi\\+.styles_orange-200__8TYMV {
  color: #ffc69e;
}

.styles_color__JXzi\\+.styles_orange-300__WkyTE {
  color: #ffa047;
}

.styles_color__JXzi\\+.styles_orange-400__YA8Hj {
  color: #ff7b42;
}

.styles_color__JXzi\\+.styles_orange-500__aray- {
  color: #ee4920;
}

.styles_color__JXzi\\+.styles_turquoise-50__0FWNE {
  color: transparent;
}

.styles_color__JXzi\\+.styles_turquoise-100__a0VC4 {
  color: #e6fcff;
}

.styles_color__JXzi\\+.styles_turquoise-200__9mVIZ {
  color: #b3f5ff;
}

.styles_color__JXzi\\+.styles_turquoise-300__iLvao {
  color: #78e2f2;
}

.styles_color__JXzi\\+.styles_turquoise-400__REgvq {
  color: #00c7e6;
}

.styles_color__JXzi\\+.styles_turquoise-500__wRivc {
  color: transparent;
}

.styles_color__JXzi\\+.styles_turquoise-600__pEYht {
  color: transparent;
}

.styles_color__JXzi\\+.styles_violet-50__5Pe4t {
  color: #eae6ff;
}

.styles_color__JXzi\\+.styles_violet-100__WW4yf {
  color: #d9d1ff;
}

.styles_color__JXzi\\+.styles_violet-200__b-srN {
  color: #bfb3ff;
}

.styles_color__JXzi\\+.styles_violet-300__Cv1qz {
  color: #9d90ea;
}

.styles_color__JXzi\\+.styles_violet-400__KYLjp {
  color: #8678d9;
}

.styles_color__JXzi\\+.styles_violet-500__e4ELR {
  color: #6f5ccc;
}

.styles_color__JXzi\\+.styles_snow-50__SDNPa {
  color: white;
}

.styles_color__JXzi\\+.styles_snow-100__rPswC {
  color: #f7f7f7;
}

.styles_color__JXzi\\+.styles_snow-200__45oJF {
  color: #f0efef;
}

.styles_color__JXzi\\+.styles_snow-300__ZZhSL {
  color: #e6e6e6;
}

.styles_color__JXzi\\+.styles_snow-400__0bzdQ {
  color: #e1e0e0;
}

.styles_color__JXzi\\+.styles_snow-500__VvU\\+k {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__xsmOz.styles_ocean__YdxW- {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__xsmOz.styles_ocean-light__dO08d {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__xsmOz.styles_green__61EjD {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__xsmOz.styles_green-light__PXhBd {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__xsmOz.styles_red__j3OjZ {
  background-color: #e23661;
  color: white;
}

.styles_background-color__xsmOz.styles_red-light__lfWQI {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__xsmOz.styles_orange__gRVXI {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__xsmOz.styles_orange-light__h8Eps {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__xsmOz.styles_space__F8LP9 {
  background-color: #616161;
  color: white;
}

.styles_background-color__xsmOz.styles_space-light__LSPx6 {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__xsmOz.styles_gray-light__jqVUH {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__xsmOz.styles_violet__nXdnM {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__xsmOz.styles_violet-light__08Jp5 {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__xsmOz.styles_yellow__osIwX {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__xsmOz.styles_yellow-light__USh9b {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_roomsList__BdjYq {
  flex-grow: 1;
  overflow-y: auto;
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/components/chat/sidebar/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;AA0UJ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.roomsList {\n    flex-grow: 1;\n    overflow-y: auto;\n    position: relative;\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__JXzi+`,
	"ocean-50": `styles_ocean-50__X59v+`,
	"ocean-100": `styles_ocean-100__EdKRE`,
	"ocean-200": `styles_ocean-200__sSlq9`,
	"ocean-300": `styles_ocean-300__IUwSg`,
	"ocean-400": `styles_ocean-400__Uxy7R`,
	"ocean-500": `styles_ocean-500__-pl5N`,
	"ocean-600": `styles_ocean-600__MbnwR`,
	"space-50": `styles_space-50__CpgSu`,
	"space-100": `styles_space-100__0in8r`,
	"space-200": `styles_space-200__-5kZS`,
	"space-300": `styles_space-300__y8tps`,
	"space-400": `styles_space-400__JfTXJ`,
	"space-500": `styles_space-500__DHi63`,
	"gray-50": `styles_gray-50__BPL78`,
	"gray-100": `styles_gray-100__w4yHf`,
	"gray-200": `styles_gray-200__vQN7V`,
	"gray-300": `styles_gray-300__4Q-H0`,
	"gray-400": `styles_gray-400__wFpDT`,
	"gray-500": `styles_gray-500__AXoZx`,
	"green-50": `styles_green-50__lY50r`,
	"green-100": `styles_green-100__bnEzv`,
	"green-200": `styles_green-200__W5M6R`,
	"green-300": `styles_green-300__m++do`,
	"green-400": `styles_green-400__oq6yX`,
	"green-500": `styles_green-500__XNpnT`,
	"red-50": `styles_red-50__4HS07`,
	"red-100": `styles_red-100__yjZSd`,
	"red-200": `styles_red-200__oKDl7`,
	"red-300": `styles_red-300__pp24U`,
	"red-400": `styles_red-400__sI9Tf`,
	"red-500": `styles_red-500__w2EA5`,
	"yellow-50": `styles_yellow-50__7W8Y8`,
	"yellow-100": `styles_yellow-100__LhL5q`,
	"yellow-200": `styles_yellow-200__7NFrt`,
	"yellow-300": `styles_yellow-300__Jstr0`,
	"yellow-400": `styles_yellow-400__6QqBQ`,
	"yellow-500": `styles_yellow-500__P8pAr`,
	"orange-50": `styles_orange-50__Sk5g9`,
	"orange-100": `styles_orange-100__QnbuV`,
	"orange-200": `styles_orange-200__8TYMV`,
	"orange-300": `styles_orange-300__WkyTE`,
	"orange-400": `styles_orange-400__YA8Hj`,
	"orange-500": `styles_orange-500__aray-`,
	"turquoise-50": `styles_turquoise-50__0FWNE`,
	"turquoise-100": `styles_turquoise-100__a0VC4`,
	"turquoise-200": `styles_turquoise-200__9mVIZ`,
	"turquoise-300": `styles_turquoise-300__iLvao`,
	"turquoise-400": `styles_turquoise-400__REgvq`,
	"turquoise-500": `styles_turquoise-500__wRivc`,
	"turquoise-600": `styles_turquoise-600__pEYht`,
	"violet-50": `styles_violet-50__5Pe4t`,
	"violet-100": `styles_violet-100__WW4yf`,
	"violet-200": `styles_violet-200__b-srN`,
	"violet-300": `styles_violet-300__Cv1qz`,
	"violet-400": `styles_violet-400__KYLjp`,
	"violet-500": `styles_violet-500__e4ELR`,
	"snow-50": `styles_snow-50__SDNPa`,
	"snow-100": `styles_snow-100__rPswC`,
	"snow-200": `styles_snow-200__45oJF`,
	"snow-300": `styles_snow-300__ZZhSL`,
	"snow-400": `styles_snow-400__0bzdQ`,
	"snow-500": `styles_snow-500__VvU+k`,
	"background-color": `styles_background-color__xsmOz`,
	"ocean": `styles_ocean__YdxW-`,
	"ocean-light": `styles_ocean-light__dO08d`,
	"green": `styles_green__61EjD`,
	"green-light": `styles_green-light__PXhBd`,
	"red": `styles_red__j3OjZ`,
	"red-light": `styles_red-light__lfWQI`,
	"orange": `styles_orange__gRVXI`,
	"orange-light": `styles_orange-light__h8Eps`,
	"space": `styles_space__F8LP9`,
	"space-light": `styles_space-light__LSPx6`,
	"gray-light": `styles_gray-light__jqVUH`,
	"violet": `styles_violet__nXdnM`,
	"violet-light": `styles_violet-light__08Jp5`,
	"yellow": `styles_yellow__osIwX`,
	"yellow-light": `styles_yellow-light__USh9b`,
	"roomsList": `styles_roomsList__BdjYq`
};
export default ___CSS_LOADER_EXPORT___;
